import { STATUS } from "@/utils/constants";

import * as actionTypes from "./dynamic-table-views.actionTypes";

const initialState = {
  isFetchingViews: false,
  isFetchingStatus: STATUS.IDLE,
  isVisible: false,
  isCreateViewFormVisible: false,
  views: [],
  activeView: null,
  selectedView: { uid: "none", name: "None" },
  defaultView: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VIEWS: {
      return { ...state, views: action.payload };
    }

    case actionTypes.SET_ACTIVE_VIEW: {
      return { ...state, activeView: action.payload };
    }

    case actionTypes.SET_IS_FETCHING_VIEWS: {
      return { ...state, isFetchingViews: action.payload };
    }

    case actionTypes.SET_IS_FETCHING_STATUS: {
      return { ...state, isFetchingStatus: action.payload };
    }

    case actionTypes.SET_IS_VISIBLE: {
      return { ...state, isVisible: action.payload };
    }

    case actionTypes.SET_IS_CREATE_VIEW_FORM_VISIBLE: {
      return { ...state, isCreateViewFormVisible: action.payload };
    }

    case actionTypes.SET_SELECTED_VIEW: {
      return { ...state, selectedView: action.payload };
    }

    case actionTypes.SET_DEFAULT_VIEW: {
      return { ...state, defaultView: action.payload };
    }

    case actionTypes.RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
